import React, { useState, useEffect, useContext } from 'react';
import { auth } from '../firebaseClient';
import { useNavigate, useLocation } from 'react-router-dom'; // <-- Neu: useLocation
import { signOut } from 'firebase/auth';
import './Settings.css';
import { CustomerContext } from '../App';

function Settings() {
  const navigate = useNavigate();
  const location = useLocation(); // <-- um den Pfad zu prüfen

  const [isAdmin, setIsAdmin] = useState(false);
  const [newCustomerId, setNewCustomerId] = useState('');
  const [message, setMessage] = useState('');

  // Liste deiner Admin-Mails
  const adminEmails = ["prosperly.info@gmail.com"];

  // Demo check: Bist du in /demo/...?
  const isDemo = location.pathname.startsWith('/demo');

  const { selectedCustomerId } = useContext(CustomerContext);
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

  // Bei Mount: Prüfe, ob aktueller User Admin ist.
  // Aber wenn isDemo == true, setze isAdmin => false.
  useEffect(() => {
    const user = auth.currentUser;
    if (!isDemo && user && adminEmails.includes(user.email)) {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
  }, [isDemo]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  const handleCreateCustomer = async (e) => {
    e.preventDefault();
    if (!newCustomerId) {
      setMessage('Bitte geben Sie eine Customer ID ein.');
      return;
    }
    try {
      const response = await fetch(`${API_URL}/api/createCustomer`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customerId: newCustomerId })
      });
      const data = await response.json();
      if (response.ok) {
        setMessage(`Customer ${newCustomerId} erstellt. Magic Link: ${data.signUpLink}`);
        setNewCustomerId('');
      } else {
        setMessage(`Fehler: ${data.error}`);
      }
    } catch (error) {
      setMessage(`Fehler: ${error.message}`);
    }
  };

  return (
    <div className="settings-container">
      <h1 className="settings-title">Einstellungen</h1>

      {/* Admin-Bereich: nur anzeigen, wenn !isDemo und isAdmin */}
      {isAdmin && (
        <div className="section admin-section">
          <h2 className="section-title">Neuen Customer erstellen</h2>
          <form className="form" onSubmit={handleCreateCustomer}>
            <div className="form-group">
              <input
                type="text"
                placeholder="Customer ID"
                value={newCustomerId}
                onChange={(e) => setNewCustomerId(e.target.value)}
              />
            </div>
            <button type="submit" className="btn btn-primary">
              Customer erstellen
            </button>
          </form>
          {message && <p className="message">{message}</p>}
        </div>
      )}

      {/* Logout-Bereich */}
      <div className="section logout-section">
        <button className="btn btn-logout" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>
  );
}

export default Settings;
